module.exports = __webpack_public_path__ + "static/img/img3.06f8fdc6.jpeg";